/**
 * Access token lives here — module-level memory, never localStorage.
 * The refresh token is a httpOnly cookie set by the server and invisible to JS.
 */
let accessToken: string | null = null;

export const tokenStore = {
  get(): string | null { return accessToken; },
  set(token: string | null): void { accessToken = token; },
  clear(): void { accessToken = null; },
};
